import styled from 'styled-components';
import { Link } from '../../../common/components/Link';
import { ThemeColours } from '../../../common/styles/ThemeColours';
import { FontWeight } from '../../../common/styles/constants';
import { HIDE_SCROLL_BAR } from '../../../common/styles/mixins';
import { onMobile } from '../../../common/styles/onMobile';

export const LinkContainer = styled.div`
  ${HIDE_SCROLL_BAR};

  ${onMobile} {
    overflow-y: auto;
    white-space: nowrap;
  }
`;

export const LinkSectionView = styled.div`
  color: ${ThemeColours.mono600};
  font-size: 14px;
  line-height: 24px;
  padding-bottom: 16px;
`;

export const LinkTitle = styled.h2`
  color: ${ThemeColours.black};
  font-size: 16px;
  font-weight: ${FontWeight.SEMI_BOLD};
  line-height: 27px;
  padding-top: 24px;
`;

export const StyledLink = styled(Link)`
  color: ${ThemeColours.mono600};
  text-decoration: none;
  &:not(:last-of-type) {
    ::after {
      content: ' | ';
    }
  }
`;
